'use client';

import { BASE_URL } from '@/common/constants';
import { checkType } from '@/common/ultils';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import React from 'react';
// import Image from 'next/image';
const handleSubmitUpViewBanner = async (id) => {
  try {
    await fetch(`${BASE_URL}/bannerSystems/updateClick/${id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    });
  } catch {
    // alert(`Có lỗi xảy ra! ${error}`);
  }
};
const RightBanner = ({ rightBanners, deviceType }) => {
  return get(rightBanners, 'results', []).map((item) => {
    const fileUrl = checkType(deviceType === 'mobile' ? 'mobile' : 'tablet', item, 0, 'fileUrl', 'sharpMedias');
    if (!isEmpty(item?.linkTo)) {
      return (
        <a
          key={item.id}
          target="_blank"
          href={item?.linkTo}
          rel="noopener noreferrer"
          onClick={() => handleSubmitUpViewBanner(item?.id)}
          style={{ position: 'relative', width: '100%', height: 'auto' }}
          className="cursor-pointer bg-gray-300 flex items-center justify-center text-gray-600 relative w-full">
          <Image src={fileUrl} alt={item?.name ?? 'banner right'} className="w-full h-full object-cover position-initial" fill quality={85} />
          {/* <img src={fileUrl} alt={item?.name ?? 'banner right'} className="w-full h-full object-cover" loading="lazy" /> */}
        </a>
      );
    } else {
      return (
        <div key={item?.id} className="relative w-full h-full">
          <Image src={fileUrl} alt={item?.name ?? 'banner right'} className="w-full h-full object-cover position-initial" fill quality={85} />
          {/* <img src={fileUrl} alt={item?.name ?? 'banner right'} className="w-full h-full object-cover" loading="lazy" /> */}
        </div>
      );
    }
  });
};

export default RightBanner;
